import React from 'react';
import classNames from 'classnames/bind';
import styles from './PlainTextArea.scss';

const cx = classNames.bind(styles);

// const propTypes = {
//   id: React.PropTypes.string,
//   label: React.PropTypes.string,
//   value: React.PropTypes.string,
//   onChange: React.PropTypes.func,
//   isError: React.PropTypes.bool,
//   isValid: React.PropTypes.bool,
//   errorText: React.PropTypes.string,
//   noresize: React.PropTypes.bool,
//   style: React.PropTypes.object,
//   labelStyle: React.PropTypes.object,
//   placeholder: React.PropTypes.string,
//   required: React.PropTypes.bool,
// };

const defaultProps = {
};

const PlainTextArea = ({
    id,
    label,
    onChange,
    isError,
    isValid,
    errorText,
    value,
    noresize,
    style,
    labelStyle,
    placeholder,
    required,
  }) =>

    <div>
      <label htmlFor={id} className={styles.label} style={labelStyle}>
        {label}
        {required && <span className={styles.star}> *</span>}
      </label>
      <textarea
        className={cx({ textarea: true, error: isError, success: isValid, noresize })}
        name={id}
        id={id}
        value={value}
        onChange={onChange}
        style={style}
        placeholder={placeholder}
      />
      {isError && <div className={styles.errorText}>{errorText}</div>}
    </div>;


// PlainTextArea.propTypes = propTypes;
PlainTextArea.defaultProps = defaultProps;

export default PlainTextArea;
